<template>
  <div class="popup">
    <div class="popup__overlay" @click="closeModal"></div>
    <div class="popup__inner">
      <div class="popup__inner__details">
        <div  v-if="!apply" id="vjs-tab-job" data-tab-bind="job" >
          <div v-html="dataPage"></div>
        </div>
        <form  v-show="apply" class="tab-content apply-form show  has-logo ng-pristine ng-valid ng-valid-email">
          <!-- ************************| Tab 1 |************************ -->
          <div class="tab-pane active" v-if="!submitStatus">

            <div class="tab-transition-container">
              <div class="center-container" ng-class="{'submitted': submitted}">

                <h1>{{pakketData.title}}</h1>
                <p class="intro">Let us get to know you a bit better by sharing your basic info.</p>


                <ul class="form-layout">
                  <li class="input-half">
                    <label data-label="first_name">First name *</label>
                    <input type="text" v-model.trim="$v.FirstName.$model" :class="{ 'error': $v.FirstName.$error,'valid':!$v.FirstName.$invalid }" name="first_name" ng-model="formData.first_name" ng-init="formData.first_name=''"
                      class="ng-pristine ng-untouched ng-valid ng-empty">
                  </li>

                  <li class="input-half">
                    <label data-label="last_name">Last name *</label>
                    <input type="text" v-model.trim="$v.Last_name.$model" name="last_name" :class="{ 'error': $v.Last_name.$error,'valid':!$v.Last_name.$invalid }" ng-model="formData.last_name" ng-init="formData.last_name=''"
                      class="ng-pristine ng-untouched ng-valid ng-empty">
                  </li>

                  <li>
                    <label data-label="email">E-mail address *</label>
                    <input type="email" v-model="Email_address" v-model.trim="$v.Email_address.$model"  name="email" ng-model="formData.email" :class="{ 'error': $v.Email_address.$error,'valid':!$v.Email_address.$invalid }" ng-init="formData.email=''"
                      class="ng-pristine ng-untouched ng-valid ng-empty ng-valid-email">
                  </li>

                  <li>
                    <label data-label="date_of_birth">
                      Date of birth
                    </label>
                    <input ref="datebirth" type="text" v-model.trim="$v.Date_of_birth.$model" :class="{ 'error': $v.Date_of_birth.$error,'valid':!$v.Date_of_birth.$invalid }"  name="date_of_birth" placeholder="dd-mm-yyyy" ng-model="formData.date_of_birth"
                      class="ng-pristine ng-untouched ng-valid ng-empty">
                  </li>


                  <li>
                    <label data-label="city">
                      City
                    </label>
                    <input type="text" v-model.trim="$v.City.$model" :class="{ 'error': $v.City.$error,'valid':!$v.City.$invalid }" name="city" ng-model="formData.city" ng-init="formData.city=''"
                      class="ng-pristine ng-untouched ng-valid ng-empty">
                  </li>

                  <li>
                    <label data-label="country">
                      Country
                    </label>
                    <input type="text" v-model.trim="$v.Country.$model" :class="{ 'error': $v.Country.$error,'valid':!$v.Country.$invalid }" name="country" ng-model="formData.country" ng-init="formData.country=''"
                      class="ng-pristine ng-untouched ng-valid ng-empty">
                  </li>

                  <li>
                    <label data-label="phone_number">
                      Telephone number
                    </label>
                    <input type="tel" v-model="Telephone_number" v-model.trim="$v.Telephone_number.$model" :class="{ 'error': $v.Telephone_number.$error,'valid':!$v.Telephone_number.$invalid }" name="phone_number" ng-model="formData.phone_number"
                      ng-init="formData.phone_number=''" class="ng-pristine ng-untouched ng-valid ng-empty">
                  </li>
                </ul>


               
<!-- 
                <div class="question-container" data-section="education">
                  <h3>
                    Education
                  </h3>
                  <textarea name="education" v-model.trim="$v.Education.$model" :class="{ 'error': $v.Education.$error,'valid':!$v.Education.$invalid }" class="short ng-pristine ng-untouched ng-valid ng-empty"
                    ng-model="formData.education" ng-initial=""></textarea>
                </div> -->

                <!-- <div class="question-container"  data-section="work-experience">
                  <h3>
                    Experience
                  </h3>
                  <textarea name="experience" v-model.trim="$v.Experience.$model" :class="{ 'error': $v.Experience.$error,'valid':!$v.Experience.$invalid }" class="short ng-pristine ng-untouched ng-valid ng-empty"
                    ng-model="formData.experience" ng-initial=""></textarea>
                </div> -->

                <div class="resume-files">
                  <h3>
                    Upload your resume
                  </h3>
                  <div class="question-container " :class="{error:!checkFile}" data-section="resume-pdf">
                    <!-- This is conditional as the apply form editor shows a preview that doesnt have angular -->
                    <p ng-show="uploadError['resume']" style="color:red;margin-top:10px;font-size:14px !important;"
                      class="ng-binding ng-hide">
                     <input type="file" @change="checkFile=true"  ref="file"  id="file" >
                    </p>
                  </div>
                </div>

              <vue-recaptcha
              ref="recaptcha"
              @verify="onCaptchaVerified"
              @expired="onCaptchaExpired"
              @render="onCaptchaRendered"
              size="checkbox"
              :sitekey="this.sitekey">
              </vue-recaptcha>
             <div class="tab-control  next" style="    transform: scale(0.5); font-size: 45px;cursor: pointer;" @click="submit()">
          
            <span>send</span>
                </div>

              </div>
 
            </div>
          </div>
          <p  v-else class="sentsuccesfully ">
            Sent succesfully 
          </p>
        </form>

      </div>
      <div class="popup__footer">
        <a href="#" v-if="!apply" @click="applyM()" >
          apply
        </a>
      </div>
      <div class="popup__inner__close" @click="closeModal()">
        <i class="popup__inner__close__icon"></i>
      </div>

    </div>


  </div>
</template>

<script>
  import EventBus from '@/event-bus';
  import { required, minLength,email,numeric } from 'vuelidate/lib/validators';
  import axios from 'axios';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'popup',
    data() {
      return {
        sitekey: "6LeKEokaAAAAANt--Lbr__JFA9Dcmm0ncQ0lEMLc",
        widgetId: '',
        recaptchaStatus:false,
        isActive: undefined,
        selectedCupId: undefined,
        isOpen: false,
        apply: false,
        FirstName:"",
        Last_name :"",
        Email_address :"",
        Date_of_birth:"",
        City:"",
        Country:"",
        Telephone_number:"",
        Education:"",
        Experience:"",
        Upload_your_resume:undefined,
        dataPage:"",
        submitStatus:false,
        file:'',
        checkFile:true
      };
    },
    validations: {
      // file: {required},
    FirstName: {
      required,
      minLength: minLength(4)
    },
    Last_name: {
      required,
      minLength: minLength(4)
    },
    Email_address: {
      required,
     email
    },
     City: {
      required,
      minLength: minLength(4)
    }, 
    Country: {
      required,
      minLength: minLength(4)
    }, 
    Date_of_birth: {
      required
    },
    Telephone_number: {
      required,
      numeric
    },

    },
    props: {
      pakketData: {},
    },
    created() {
      // this.selectedCupId = this.selectedCupId || this.pakketData.content[0].id;
    },
    methods: {
      closeModal() {
        EventBus.$emit('close-modal', undefined);
      },
      submit() {
      console.log('submit!');
      this.$v.$touch();


      if (this.$v.$invalid  || !this.$refs.file.files[0] || !this.recaptchaStatus ) {
        if(!this.$refs.file.files[0]){
         this.checkFile = false;
        }
        setTimeout(function(){
          if($(".popup__inner .error")){
              $(".popup__inner .error")[0].scrollIntoView()
          }

        },100)
    
      } else {
      console.log('done!');
      this.checkFile = true;

          this.file = this.$refs.file.files[0];   
          let formData = new FormData();
          formData.append('Email',this.Email_address);
          formData.append('PhoneNumber',this.Telephone_number);
          formData.append('LastName',this.Last_name );
          formData.append('Education',"null");
          formData.append('Experience',"null");
          formData.append('City', this.City);
          formData.append('BirthDate',this.Date_of_birth);
          formData.append('CareerLocation',this.pakketData.location);
          formData.append('Country',this.Country);
          formData.append('CareerType',this.pakketData.type);
          formData.append('CareerTitle',this.pakketData.title);
          formData.append('FirstName',this.FirstName);
          formData.append('file', this.file);;

          this.submitStatus = true ; 
          axios.post('https://superapi.mobilityintel.com/api/LandingPage/ApplyJob',
          formData,
           {headers: {
              'Content-Type': 'multipart/form-data'
            }},
          ).then(function (response) {
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
        // do your submit logic here
        this.submitStatus = 'PENDING'
        setTimeout(() => {
          this.submitStatus = 'OK'
        }, 500)
      }
    },
      applyM(){
         $(".popup__inner").animate({ scrollTop: 0 }, "slow");
        this.apply = true ;
       let date = this.$refs.datebirth;
        console.log('date');

        console.log(date);
        function checkValue(str, max) {
          if (str.charAt(0) !== '0' || str == '00') {
            var num = parseInt(str);
            if (isNaN(num) || num <= 0 || num > max) num = 1;
            str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
          };
          return str;
        };

        date.addEventListener('input', function(e) {
          this.type = 'text';
          var input = this.value;
          if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
          var values = input.split('/').map(function(v) {
            return v.replace(/\D/g, '')
          });
          if (values[0]) values[0] = checkValue(values[0], 12);
          if (values[1]) values[1] = checkValue(values[1], 31);
          var output = values.map(function(v, i) {
            return v.length == 2 && i < 2 ? v + ' / ' : v;
          });
          this.value = output.join('').substr(0, 14);
        });

        date.addEventListener('blur', function(e) {
          this.type = 'text';
          var input = this.value;
          var values = input.split('/').map(function(v, i) {
            return v.replace(/\D/g, '')
          });
          var output = '';
          
          if (values.length == 3) {
            var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
            var month = parseInt(values[0]) - 1;
            var day = parseInt(values[1]);
            var d = new Date(year, month, day);
            if (!isNaN(d)) {
              document.getElementById('result').innerText = d.toString();
              var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
              output = dates.map(function(v) {
                v = v.toString();
                return v.length == 1 ? '0' + v : v;
              }).join(' / ');
            };
          };
          this.value = output;
        });
      },
      setToken: function(token) {
                this.form['g-recaptcha-response'] = token;
      },
      onCaptchaVerified: function(token) {
          this.recaptchaStatus = true;
      },
      onCaptchaExpired: function() {
          this.setToken('');
      },
      onCaptchaRendered: function(id) {
          this.widgetId = id;
      },
    },
    mounted(){
          axios.get(this.pakketData.fileurl).then(response => {
          //  axios.get("https://landingpageconf.s3.amazonaws.com/Data_Analysis_Specialist_qsdqdd.html").then(response => {
           this.dataPage = response.data;
        });

       
    },
    components:{VueRecaptcha}

  }

</script>

<style lang="scss" scoped>
  @import './style.scss';
</style>



// WEBPACK FOOTER //
// src/components/popup/index.vue